export default __webpack_public_path__ + "static/media/ir.fb09c2ad.svg";